import { Switch } from "@/components/ui/switch";

interface ShareWithTaggedToggleProps {
  /** Names of the people whose access depends on this toggle. Rendered in
   *  the subtext. The caller decides whether to render the toggle at all
   *  based on this list's length (capture shows it when ≥1; the detail
   *  sheet adds an owner-only gate on top). */
  names: string[];
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  disabled?: boolean;
}

export default function ShareWithTaggedToggle({
  names,
  checked,
  onCheckedChange,
  disabled,
}: ShareWithTaggedToggleProps) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-border/60 bg-card px-3 py-2.5">
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground">
          Share with tagged people
        </p>
        <p className="text-[11px] text-muted-foreground mt-0.5">
          Grants access to {names.join(", ")}
        </p>
      </div>
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="mt-0.5"
      />
    </div>
  );
}
